(ns pfo.widget.help
  (:require [reagent.core :refer [atom] :refer-macros [with-let]]
            [pfo.util :as util]))

(defn help-popover
  ([content] (help-popover content {}))
  ([content {:keys [align size wide offset] :or {align :left size :s wide false offset 180}}]
   (with-let [*open (atom false)]
     [:div.c-help-popover
      [:img {:class    (str "c-help-popover__icon svg-icon--" (name size))
             :src      "/static/img/icons/help.svg"
             :on-click (util/handler #(swap! *open not))}]
      (when @*open
        [:<>
         [:div.c-help-popover__backdrop {:on-click (util/handler #(reset! *open false))}]
         [:div {:class (str "c-help-popover__popup"
                            (when (= align :right) " c-help-popover__popup--right")
                            (when wide " c-help-popover__popup--wide"))
                :style (when (not= align :right) {:left (str "-" offset "px")})}
          [:button.c-help-popover__close {:on-click (util/handler #(reset! *open false))}]
          content]])])))
